import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import AuthInitializer from "@/components/auth/AuthInitializer";

export default function RootLayout() {
  return (
    <>
      <AuthInitializer />
      <Outlet />
    </>
  );
}
